<div class="d-flex flex-column justify-content-between gap-5 px-4 py-4">
  <div class="d-flex flex-column gap-2">
    <span
      class="sidenav-join-block__number-of-registered-merchants primary-color"
    >
      {{ merchantCount }}
    </span>

    <span>{{ "SIDENAV.JOIN_BLOCK.COUNTER_DESCRIPTION" | translate }}</span>
  </div>

  <a [routerLink]="['/auth/merchant-registration']">
    <button [color]="'primary'" class="width-100" mat-raised-button>
      {{ "SIDENAV.JOIN_BLOCK.JOIN_BUTTON_LABEL" | translate }}
    </button>
  </a>
</div>
